import axiosInstance from "../utils/axios";
import {
    SocialAccount,
    SocialAccountOption,
    SocialContentPublication, SocialPlatform,
    SocialPlatformOption, SocialPostRequest,
    SocialPostTypeOption,
} from "../types/socialTypes";
const baseURL = "/social";

interface SocialOptionResponse{
    socialPlatforms: SocialPlatformOption[]
    socialAccounts: SocialAccountOption[]
    socialPostTypes: SocialPostTypeOption[]
}

export async function getSocialOptions(): Promise<SocialOptionResponse> {
    const response = await axiosInstance.get(`${baseURL}/social_options`);
    return response.data;
}

export async function socialPost(socialClipId: string, post: SocialPostRequest): Promise<SocialContentPublication> {
    const response = await axiosInstance.post(`${baseURL}/post/${socialClipId}`, post);
    return response.data;
}

export async function getVideoContentSocialPosts(videoContentId: string, abortController: AbortController | null = null): Promise<SocialContentPublication[]> {
    const response = abortController ? await axiosInstance.get(`${baseURL}/videoContentPosts/${videoContentId}`, {signal: abortController.signal}) : await axiosInstance.get(`${baseURL}/videoContentPosts/${videoContentId}`);
    return response.data;
}

export async function deletePublication(publicationId: string): Promise<SocialContentPublication[]> {
    const response = await axiosInstance.delete(`${baseURL}/publication/${publicationId}`);
    return response.data;
}

export async function getSocialClipsByEditState(editSessionId: string): Promise<any[]> {
    const response = await axiosInstance.get(`/social_clips/socialClipsByEditState/${editSessionId}`);
    return response.data;
}

export async function getGroupedAccounts(): Promise<SocialPlatform[]> {
    const response = await axiosInstance.get(`${baseURL}/groupedSocialAccounts`);
    return response.data;
}

export async function createSocialAccount(socialAccount: SocialAccount): Promise<{id: string}> {
    const response = await axiosInstance.post(`${baseURL}/createSocialAccount`, socialAccount);
    return response.data;
}

export async function deleteSocialAccount(social_account_id: string): Promise<any> {
    const response = await axiosInstance.delete(`${baseURL}/deleteSocialAccount/${social_account_id}`);
    return response.data
}

export async function updateSocialAccount(social_account_id: string, social_account: SocialAccount): Promise<any> {
    const response = await axiosInstance.put(`${baseURL}/updateSocialAccount/${social_account_id}`, social_account);

    return response.data;
}

export async function loginWithGoogle(): Promise<any> {
    const response = await axiosInstance.get(baseURL + '/google/auth');
    return response.data.url;
}

export async function loginWithInstagram(): Promise<any> {
    const response = await axiosInstance.get(baseURL + '/instagram/auth');
    return response.data.url;
}

export async function loginWithFacebook(): Promise<any> {
    const response = await axiosInstance.get(baseURL + `/facebook/auth`);
    return response.data.url
}

export async function loginWithTikTok(): Promise<any> {
    const response = await axiosInstance.get(baseURL + `/tiktok/auth`);
    return response.data.url
}

export async function createTelegramInvitation(): Promise<{invite: string}> {
    const response = await axiosInstance.post(baseURL + '/telegram/invitation');
    return response.data
}
